export const hasGuestwiseConsent = () => {
    return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing;
};

export const pushFieldToDataLayer = (eventName, fieldName, fieldValue) => {
    if (!hasGuestwiseConsent()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        fieldName: fieldName,
        fieldValue: fieldValue,
    });
};
